<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Navigation -->
    <NavBar />
    
    <!-- Hero Section -->
    <HeroSection />
    
    <!-- Features Section -->
    <FeaturesSection />
    
    <!-- Screenshots Section -->
    <ScreenshotsSection />
    
    <!-- Testimonials Section -->
    <TestimonialsSection />
    
    <!-- FAQ Section -->
    <FAQSection />
    
    <!-- CTA Section -->
    <CTASection />
    
    <!-- Footer -->
    <Footer />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import HeroSection from './components/HeroSection.vue'
import FeaturesSection from './components/FeaturesSection.vue'
import ScreenshotsSection from './components/ScreenshotsSection.vue'
import TestimonialsSection from './components/TestimonialsSection.vue'
import FAQSection from './components/FAQSection.vue'
import CTASection from './components/CTASection.vue'
import Footer from './components/Footer.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    HeroSection,
    FeaturesSection,
    ScreenshotsSection,
    TestimonialsSection,
    FAQSection,
    CTASection,
    Footer
  }
}
</script>
